module.exports = __webpack_public_path__ + "static/media/replay-10.2df076ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/replay-10.svg
// module id = 977
// module chunks = 0